import { customerApi } from "../../utils/apiConfig";

export const getTodayFormsAdminDetail = (id) => {
  return customerApi.get(`/getTodayFormsAdminDetail/${id}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getTodayFormsAdmin = (makina) => {
  return customerApi.get(`/getTodayFormsAdmin/${makina}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
